import { render, staticRenderFns } from "./ReportUpdateData.vue?vue&type=template&id=65eb0661&scoped=true"
import script from "./ReportUpdateData.vue?vue&type=script&lang=js"
export * from "./ReportUpdateData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb0661",
  null
  
)

export default component.exports